import axios from '@axios'

export default {
  namespaced: true,
  actions: {

    getRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('userGetLinked', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getPermissions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('permissions', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    submitPermissions(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.post('permissions', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('roles', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    fetchRole(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`roles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    addRole(ctx, roleData) {
      return new Promise((resolve, reject) => {
        axios.post('roles', roleData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },


    deleteRole(ctx, roleName) {
      return new Promise((resolve, reject) => {
        axios.delete(`roles/${roleName}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    editRole(ctx, form) {
      return new Promise((resolve, reject) => {
        axios.put(`roles/${form.id}`, form)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
